// components/lead-generation/core/SearchInterface.js

import React, { useState } from 'react';

export default function SearchInterface({
  onSearch,
  onToggleFilters,
  isSearching,
  hasFilters,
  placeholder = "Enter business type, location, or industry keywords...",
  searchExamples = ['coffee shops nottingham', 'tech startups london', 'manufacturing companies', 'professional services']
}) {
  const [searchType, setSearchType] = useState('business');
  const [query, setQuery] = useState('');

  const searchTypes = [
    { id: 'business', name: 'Local Businesses', icon: 'fas fa-store' },
    { id: 'professionals', name: 'Professionals', icon: 'fas fa-user-tie' },
    { id: 'companies', name: 'Companies', icon: 'fas fa-building' },
    { id: 'industry', name: 'Industry Specific', icon: 'fas fa-industry' }
  ];

  const handleSearch = () => {
    if (query.trim()) {
      onSearch({ type: searchType, query: query.trim() });
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-6">
      <div className="space-y-4">
        {/* Search Type Selection */}
        <div className="flex flex-wrap gap-3">
          {searchTypes.map((type) => (
            <button
              key={type.id}
              onClick={() => setSearchType(type.id)}
              className={`flex items-center px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                searchType === type.id
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <i className={`${type.icon} mr-2`} />
              {type.name}
            </button>
          ))}
        </div>

        {/* Search Input */}
        <div className="flex space-x-3">
          <div className="flex-1">
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder={placeholder}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
            />
          </div>
          <button
            onClick={onToggleFilters}
            className={`px-4 py-3 rounded-lg font-medium transition-all ${
              hasFilters
                ? 'bg-purple-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            <i className="fas fa-filter mr-2" />
            Filters
          </button>
          <button
            onClick={handleSearch}
            disabled={isSearching || !query.trim()}
            className="px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-medium rounded-lg hover:from-blue-700 hover:to-purple-700 disabled:from-gray-400 disabled:to-gray-400 transition-all"
          >
            {isSearching ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />
                Searching...
              </>
            ) : (
              <>
                <i className="fas fa-search mr-2" />
                Find Leads
              </>
            )}
          </button>
        </div>

        {/* Search Examples */}
        <div className="flex flex-wrap gap-2 text-sm text-gray-600">
          <span>Try:</span>
          {searchExamples.map((example) => (
            <button
              key={example}
              onClick={() => setQuery(example)}
              className="text-blue-600 hover:text-blue-800 hover:underline"
            >
              "{example}"
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}